module.exports = __webpack_public_path__ + "static/img/rank_153.480b31a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_153.png
// module id = fnH3
// module chunks = 1